import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import projectCategory from "../../helpers/ProjectCategory";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import "../../css/Admin-Projects/UploadProject.css";
import Spinner from "../Spinner";

const UploadProject = ({ onClose, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const [uploadProgressImage, setuploadProgressImage] = useState(0);
  const [uploadProgressVideo, setuploadProgressVideo] = useState(0);
  const [data, setData] = useState({
    projectName: "",
    projectGitLink: "",
    projectCategory: "",
    projectImage: [],
    projectVideo: [],
    projectDescription: "",
  });
  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  async function handleUploadProduct(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.projectName}-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setuploadProgressImage(progress);
          console.log("Upload is " + progress + "% done");
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              projectImage: [...(prev.projectImage || []), downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  async function handleUploadProjectVideo(e) {
    setLoading(true);
    const video = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `${data?.projectName}-${video.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, video);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Video Upload is " + progress + "% done");
          setuploadProgressVideo(progress)
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              projectVideo: [...(prev.projectVideo || []), downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }

  const handleDeleteProductImage = (index) => {
    const newProjectImage = [...data.projectImage];
    newProjectImage.splice(index, 1);
    setData((pre) => ({
      ...pre,
      projectImage: newProjectImage,
    }));
  };

  const handleDeleteProjectVideo = (index) => {
    const newProjectVideo = [...data.projectVideo];
    newProjectVideo.splice(index, 1);
    setData((pre) => ({
      ...pre,
      projectVideo: newProjectVideo,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await addDoc(collection(db, "projects"), data);
    setLoading(false);
    toast.success("Project Added");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Add Project</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="projectName">Project Name :</label>
          <input
            type="text"
            id="projectName"
            placeholder="Enter project name"
            value={data.projectName}
            name="projectName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="projectGitLink">Project GitLink :</label>
          <input
            type="text"
            id="projectGitLink"
            placeholder="Enter project GitLink"
            value={data.projectGitLink}
            name="projectGitLink"
            onChange={handleOnChange}
            className="input"
          />

          <label htmlFor="projectCategory" className="label">
            Category :
          </label>
          <select
            required
            value={data.projectCategory}
            name="projectCategory"
            onChange={handleOnChange}
            className="input"
          >
            <option value="">Select Category</option>
            {projectCategory.map((el, index) => (
              <option value={el.value} key={el.value + index}>
                {el.label}
              </option>
            ))}
          </select>

          <label htmlFor="projectImage" className="label">
            Project Image :
          </label>
          <label htmlFor="uploadImageInput">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Project Image</p>
                <input
                  type="file"
                  id="uploadImageInput"
                  className="hidden"
                  onChange={handleUploadProduct}
                />
              </div>
            </div>
          </label>
          {uploadProgressImage > 0 && uploadProgressImage < 100 && (
            <label style={{color:'blue',textAlign:'center'}}>{`Upload is ${uploadProgressImage}% done`}</label>
          )}

          <div>
            {data.projectImage.length > 0 ? (
              <div className="image-preview" >
                {data.projectImage.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteProductImage(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Project Image</p>
            )}
          </div>

          <label htmlFor="projectVideo" className="label">
            Project Video :
          </label>
          <label htmlFor="uploadVideoInput">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Project Video</p>
                <input
                  type="file"
                  id="uploadVideoInput"
                  className="hidden"
                  onChange={handleUploadProjectVideo}
                />
              </div>
            </div>
          </label>
          {uploadProgressVideo > 0 && uploadProgressVideo < 100 && (
            <label style={{color:'blue',textAlign:'center'}}>{`Upload is ${uploadProgressVideo}% done`}</label>
          )}
          <div>
            {data.projectVideo.length > 0 ? (
              <div className="video-preview">
                {data.projectVideo.map((el, index) => (
                  <div className="video-container" key={index}>
                    <video src={el} className="video" controls />
                    <div
                      className="video-delete-icon"
                      onClick={() => handleDeleteProjectVideo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Project Video</p>
            )}
          </div>

          <label htmlFor="projectDescription" className="label">
            Description :
          </label>
          <textarea
            className="textarea"
            placeholder="Enter project description"
            rows={3}
            value={data.projectDescription}
            name="projectDescription"
            onChange={handleOnChange}
          />
          <button className="submit-button" disabled={loading}>
            Add Project
          </button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};

export default UploadProject;
